const cantidadEmpleos = {
  'hace 1 semana': 'hace 7 días',
  'hace 1 mes': 'hace 30 días',
  'hace 2 meses': 'hace 60 días',
}

export default cantidadEmpleos
